// Voorleesknop op het bord: de schakelaar per gezinslid (readAloudApp.nl.ts).
export const appReadAloudTr = {
    setting: 'Panoda sesli okuma düğmesi',
    settingHint: 'Büyük bir düğme görevleri, randevuları ve mesajları sesli okur. Henüz okuyamayanlar için kullanışlı.',
    language: 'Sesli okuma ve çağrıların dili',
    languageHint: 'Pano görevleri, randevuları ve çağrıları bu dilde sesli okur. Başlıklar yazdığınız gibi okunur.',
    languageBoard: 'Pano dili ({language})',
    languageMember: 'Sesli okuma dili',
    languageMemberHint: 'Başlıklar yazdığınız gibi okunur.',
    languageFamily: 'Aile ile aynı ({language})',
    saved: 'Kaydedildi',
};
//# sourceMappingURL=readAloudApp.tr.js.map